import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import English translation files
import commonEn from '../locales/en/common.json';
import translationEn from '../locales/en/translation.json';
import authEn from '../locales/en/auth.json';
import profileEn from '../locales/en/profile.json';
import flixEn from '../locales/en/flix.json';
import homeEn from '../locales/en/home.json';
import onlineCourseEn from '../locales/en/online-course.json';
import kanbanEn from '../locales/en/kanban.json';
import mentoriaContinuadaEn from '../locales/en/mentoria-continuada.json';
import certificatesEn from '../locales/en/certificates.json';
import agendaEn from '../locales/en/agenda.json';
import zoomEn from '../locales/en/zoom.json';
import mentorfyMeetingEn from '../locales/en/mentorfy-meeting.json';
import relatorioEn from '../locales/en/relatorio.json';
import tasksEn from '../locales/en/tasks.json';
import messagesEn from '../locales/en/messages.json';
import eventosEn from '../locales/en/eventos.json';
import gravacoesEn from '../locales/en/gravacoes.json';
import gamificationEn from '../locales/en/gamification.json';
import purchasesEn from '../locales/en/purchases.json';
import teamViewEn from '../locales/en/team-view.json';

// Import Portuguese translation files
import commonPt from '../locales/pt/common.json';
import translationPt from '../locales/pt/translation.json';
import authPt from '../locales/pt/auth.json';
import profilePt from '../locales/pt/profile.json';
import flixPt from '../locales/pt/flix.json';
import homePt from '../locales/pt/home.json';
import onlineCoursePt from '../locales/pt/online-course.json';
import kanbanPt from '../locales/pt/kanban.json';
import mentoriaContinuadaPt from '../locales/pt/mentoria-continuada.json';
import certificatesPt from '../locales/pt/certificates.json';
import agendaPt from '../locales/pt/agenda.json';
import zoomPt from '../locales/pt/zoom.json';
import mentorfyMeetingPt from '../locales/pt/mentorfy-meeting.json';
import relatorioPt from '../locales/pt/relatorio.json';
import tasksPt from '../locales/pt/tasks.json';
import messagesPt from '../locales/pt/messages.json';
import eventosPt from '../locales/pt/eventos.json';
import gravacoesPt from '../locales/pt/gravacoes.json';
import gamificationPt from '../locales/pt/gamification.json';
import purchasesPt from '../locales/pt/purchases.json';
import teamViewPt from '../locales/pt/team-view.json';

// Import Spanish translation files
import commonEs from '../locales/es/common.json';
import translationEs from '../locales/es/translation.json';
import authEs from '../locales/es/auth.json';
import profileEs from '../locales/es/profile.json';
import flixEs from '../locales/es/flix.json';
import homeEs from '../locales/es/home.json';
import onlineCourseEs from '../locales/es/online-course.json';
import kanbanEs from '../locales/es/kanban.json';
import mentoriaContinuadaEs from '../locales/es/mentoria-continuada.json';
import certificatesEs from '../locales/es/certificates.json';
import agendaEs from '../locales/es/agenda.json';
import zoomEs from '../locales/es/zoom.json';
import mentorfyMeetingEs from '../locales/es/mentorfy-meeting.json';
import tasksEs from '../locales/es/tasks.json';
import messagesEs from '../locales/es/messages.json';
import eventosEs from '../locales/es/eventos.json';
import gravacoesEs from '../locales/es/gravacoes.json';
import gamificationEs from '../locales/es/gamification.json';
import purchasesEs from '../locales/es/purchases.json';
import teamViewEs from '../locales/es/team-view.json';

// Import German translation files
import commonDe from '../locales/de/common.json';
import translationDe from '../locales/de/translation.json';
import authDe from '../locales/de/auth.json';
import profileDe from '../locales/de/profile.json';
import flixDe from '../locales/de/flix.json';
import homeDe from '../locales/de/home.json';
import onlineCourseDe from '../locales/de/online-course.json';
import kanbanDe from '../locales/de/kanban.json';
import mentoriaContinuadaDe from '../locales/de/mentoria-continuada.json';
import certificatesDe from '../locales/de/certificates.json';
import agendaDe from '../locales/de/agenda.json';
import zoomDe from '../locales/en/zoom.json';
import mentorfyMeetingDe from '../locales/de/mentorfy-meeting.json';
import tasksDe from '../locales/de/tasks.json';
import messagesDe from '../locales/de/messages.json';
import eventosDe from '../locales/de/eventos.json';
import gravacoesDe from '../locales/de/gravacoes.json';
import gamificationDe from '../locales/de/gamification.json';
import purchasesDe from '../locales/de/purchases.json';
import teamViewDe from '../locales/de/team-view.json';

// Import French translation files
import commonFr from '../locales/fr/common.json';
import translationFr from '../locales/fr/translation.json';
import authFr from '../locales/fr/auth.json';
import profileFr from '../locales/fr/profile.json';
import flixFr from '../locales/fr/flix.json';
import homeFr from '../locales/fr/home.json';
import onlineCourseFr from '../locales/fr/online-course.json';
import kanbanFr from '../locales/fr/kanban.json';
import mentoriaContinuadaFr from '../locales/fr/mentoria-continuada.json';
import certificatesFr from '../locales/fr/certificates.json';
import agendaFr from '../locales/fr/agenda.json';
import zoomFr from '../locales/en/zoom.json';
import mentorfyMeetingFr from '../locales/fr/mentorfy-meeting.json';
import tasksFr from '../locales/fr/tasks.json';
import messagesFr from '../locales/fr/messages.json';
import eventosFr from '../locales/fr/eventos.json';
import gravacoesFr from '../locales/fr/gravacoes.json';
import gamificationFr from '../locales/fr/gamification.json';
import purchasesFr from '../locales/fr/purchases.json';
import teamViewFr from '../locales/fr/team-view.json';

// Import Traditional Chinese translation files
import commonZhTW from '../locales/zh-TW/common.json';
import translationZhTW from '../locales/zh-TW/translation.json';
import authZhTW from '../locales/zh-TW/auth.json';
import profileZhTW from '../locales/zh-TW/profile.json';
import flixZhTW from '../locales/zh-TW/flix.json';
import homeZhTW from '../locales/zh-TW/home.json';
import onlineCourseZhTW from '../locales/zh-TW/online-course.json';
import kanbanZhTW from '../locales/zh-TW/kanban.json';
import mentoriaContinuadaZhTW from '../locales/zh-TW/mentoria-continuada.json';
import certificatesZhTW from '../locales/zh-TW/certificates.json';
import agendaZhTW from '../locales/zh-TW/agenda.json';
import zoomZhTW from '../locales/en/zoom.json';
import mentorfyMeetingZhTW from '../locales/zh-TW/mentorfy-meeting.json';
import tasksZhTW from '../locales/zh-TW/tasks.json';
import messagesZhTW from '../locales/zh-TW/messages.json';
import eventosZhTW from '../locales/zh-TW/eventos.json';
import gravacoesZhTW from '../locales/zh-TW/gravacoes.json';
import gamificationZhTW from '../locales/zh-TW/gamification.json';
import purchasesZhTW from '../locales/zh-TW/purchases.json';
import teamViewZhTW from '../locales/zh-TW/team-view.json';

// Resources object with all translations
const resources = {
  en: {
    common: commonEn,
    translation: translationEn,
    auth: authEn,
    profile: profileEn,
    flix: flixEn,
    home: homeEn,
    'online-course': onlineCourseEn,
    kanban: kanbanEn,
    'mentoria-continuada': mentoriaContinuadaEn,
    certificates: certificatesEn,
    agenda: agendaEn,
    zoom: zoomEn,
    tasks: tasksEn,
    messages: messagesEn,
    eventos: eventosEn,
    gravacoes: gravacoesEn,
    gamification: gamificationEn,
    purchases: purchasesEn,
    'team-view': teamViewEn,
    'mentorfy-meeting': mentorfyMeetingEn,
    relatorio: relatorioEn,
  },
  pt: {
    common: commonPt,
    translation: translationPt,
    auth: authPt,
    profile: profilePt,
    flix: flixPt,
    home: homePt,
    'online-course': onlineCoursePt,
    kanban: kanbanPt,
    'mentoria-continuada': mentoriaContinuadaPt,
    certificates: certificatesPt,
    agenda: agendaPt,
    zoom: zoomPt,
    tasks: tasksPt,
    messages: messagesPt,
    eventos: eventosPt,
    gravacoes: gravacoesPt,
    gamification: gamificationPt,
    purchases: purchasesPt,
    'team-view': teamViewPt,
    'mentorfy-meeting': mentorfyMeetingPt,
    relatorio: relatorioPt,
  },
  es: {
    common: commonEs,
    translation: translationEs,
    auth: authEs,
    profile: profileEs,
    flix: flixEs,
    home: homeEs,
    'online-course': onlineCourseEs,
    kanban: kanbanEs,
    'mentoria-continuada': mentoriaContinuadaEs,
    certificates: certificatesEs,
    agenda: agendaEs,
    zoom: zoomEs,
    tasks: tasksEs,
    messages: messagesEs,
    eventos: eventosEs,
    gravacoes: gravacoesEs,
    gamification: gamificationEs,
    purchases: purchasesEs,
    'team-view': teamViewEs,
    'mentorfy-meeting': mentorfyMeetingEs,
    relatorio: relatorioEn,
  },
  de: {
    common: commonDe,
    translation: translationDe,
    auth: authDe,
    profile: profileDe,
    flix: flixDe,
    home: homeDe,
    'online-course': onlineCourseDe,
    kanban: kanbanDe,
    'mentoria-continuada': mentoriaContinuadaDe,
    certificates: certificatesDe,
    agenda: agendaDe,
    zoom: zoomDe,
    tasks: tasksDe,
    messages: messagesDe,
    eventos: eventosDe,
    gravacoes: gravacoesDe,
    gamification: gamificationDe,
    purchases: purchasesDe,
    'team-view': teamViewDe,
    'mentorfy-meeting': mentorfyMeetingDe,
    relatorio: relatorioEn,
  },
  fr: {
    common: commonFr,
    translation: translationFr,
    auth: authFr,
    profile: profileFr,
    flix: flixFr,
    home: homeFr,
    'online-course': onlineCourseFr,
    kanban: kanbanFr,
    'mentoria-continuada': mentoriaContinuadaFr,
    certificates: certificatesFr,
    agenda: agendaFr,
    zoom: zoomFr,
    tasks: tasksFr,
    messages: messagesFr,
    eventos: eventosFr,
    gravacoes: gravacoesFr,
    gamification: gamificationFr,
    purchases: purchasesFr,
    'team-view': teamViewFr,
    'mentorfy-meeting': mentorfyMeetingFr,
    relatorio: relatorioEn,
  },
  'zh-TW': {
    common: commonZhTW,
    translation: translationZhTW,
    auth: authZhTW,
    profile: profileZhTW,
    flix: flixZhTW,
    home: homeZhTW,
    'online-course': onlineCourseZhTW,
    kanban: kanbanZhTW,
    'mentoria-continuada': mentoriaContinuadaZhTW,
    certificates: certificatesZhTW,
    agenda: agendaZhTW,
    zoom: zoomZhTW,
    tasks: tasksZhTW,
    messages: messagesZhTW,
    eventos: eventosZhTW,
    gravacoes: gravacoesZhTW,
    gamification: gamificationZhTW,
    purchases: purchasesZhTW,
    'team-view': teamViewZhTW,
    'mentorfy-meeting': mentorfyMeetingZhTW,
    relatorio: relatorioEn,
  },
};

// Default namespaces that will be loaded
const defaultNS = ['common', 'translation', 'auth', 'profile', 'flix', 'home', 'online-course', 'kanban', 'mentoria-continuada', 'certificates', 'agenda', 'zoom', 'mentorfy-meeting', 'relatorio', 'tasks', 'eventos', 'messages', 'gravacoes', 'gamification', 'team-view'];

// Supported languages
const SUPPORTED_LANGUAGES = ['en', 'pt', 'es', 'de', 'fr', 'zh-TW'] as const;

const normalizeToSupportedLanguage = (language?: string | null): string => {
  if (!language) return 'pt'

  // Exact supported code (ex: zh-TW)
  if (SUPPORTED_LANGUAGES.includes(language as any)) {
    return language
  }

  // Regional variant fallback (ex: pt-BR -> pt)
  const normalizedLanguage = language.split('-')[0]?.toLowerCase()
  if (SUPPORTED_LANGUAGES.includes(normalizedLanguage as any)) {
    return normalizedLanguage
  }

  return 'pt'
}

// Get saved language from localStorage or detect from browser
const getSavedLanguage = (): string => {
  if (typeof window !== 'undefined') {
    // First check localStorage
    const savedLanguage = localStorage.getItem('preferredLanguage')
    if (savedLanguage) {
      return normalizeToSupportedLanguage(savedLanguage)
    }

    // Fallback to browser language
    const browserLanguage = navigator.language || navigator.languages?.[0]
    if (browserLanguage) {
      // First check if the full language code is supported (e.g., 'zh-TW')
      if (SUPPORTED_LANGUAGES.includes(browserLanguage as any)) {
        return browserLanguage
      }

      // Then normalize language code (e.g., 'pt-BR' -> 'pt', 'en-US' -> 'en')
      const normalizedLanguage = browserLanguage.split('-')[0].toLowerCase()

      // Check if normalized language is supported
      if (SUPPORTED_LANGUAGES.includes(normalizedLanguage as any)) {
        return normalizedLanguage
      }
    }

    // Default to Portuguese for compatibility with user base
    return 'pt'
  }
  return 'pt'
}

// Export function to set language programmatically
export const setLanguage = (language: string) => {
  if (typeof window !== 'undefined') {
    const normalizedLanguage = normalizeToSupportedLanguage(language)
    localStorage.setItem('preferredLanguage', normalizedLanguage)
    i18n.changeLanguage(normalizedLanguage)
  }
}

i18n
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Init i18next
  .init({
    debug: process.env.NODE_ENV === 'development',
    fallbackLng: 'pt',
    lng: getSavedLanguage(), // Use saved language, browser language, or default to Portuguese

    // Namespace configuration
    defaultNS: 'translation',
    ns: defaultNS,

    // Resources
    resources,

    // Interpolation configuration
    interpolation: {
      escapeValue: false, // React already escapes
    },

    // Loading configuration
    load: 'languageOnly',

    // Plural configuration
    pluralSeparator: '_',
    contextSeparator: '_',

    // Key separator and namespace separator
    keySeparator: '.',
    nsSeparator: ':',

    // Return objects instead of strings for nested translations
    returnObjects: false,

    // Save missing keys
    saveMissing: process.env.NODE_ENV === 'development',
    missingKeyHandler: (lng, ns, key) => {
      if (process.env.NODE_ENV === 'development') {
        console.warn(`Missing translation key: ${key} for language: ${lng} in namespace: ${ns}`);
      }
    },
  });

export default i18n;

// Export types for better TypeScript support
export type TranslationResources = typeof resources.en;
export type DefaultNamespace = typeof defaultNS[number];